import { render, staticRenderFns } from "./level1IdSelect.vue?vue&type=template&id=6d08bed6&"
import script from "./level1IdSelect.vue?vue&type=script&lang=js&"
export * from "./level1IdSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports